import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DocumentoComponent }    from './documento.component';

const SECURITY_ROUTES: Routes = [
  { path: 'credito/documento', component: DocumentoComponent }
];

export const ROUTABLE_COMPONENTS = [
];

@NgModule({
  imports: [
    RouterModule.forChild(SECURITY_ROUTES)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})
export class DocumentoRoutingModule {}
